import { render, staticRenderFns } from "./importPic.vue?vue&type=template&id=35ddaf2d&scoped=true"
import script from "./importPic.vue?vue&type=script&lang=js"
export * from "./importPic.vue?vue&type=script&lang=js"
import style0 from "./importPic.vue?vue&type=style&index=0&id=35ddaf2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddaf2d",
  null
  
)

export default component.exports